export const STATUSES = {
  cancelled: 'Cancelled',
  delivered: 'Delivered',
  delivery_in_progress: 'Delivery In Progress',
  error: 'Error',
  exception: 'Exception',
  expired: 'Expired',
  in_transit: 'In Transit',
  no_info: 'No Info',
  pre_transit: 'Pre Transit',
  return_to_sender: 'Return To Sender',
  available_for_pickup: 'Available For Pickup',
  transit_limit_exceeded: 'Transit Limit Exceeded',
  unsuccessful_delivery: 'Failure',
  customs_clearance: 'Customs Clearance'
};
